import { Injectable } from '@angular/core';
import { HttpService } from '@ecp-caf/caf-common';
import { Observable } from 'rxjs';

@Injectable()
export class ComponentPerformerService {
    constructor(private http: HttpService) {

    }
    getLookUpData(helpId: string, su: string, pageIndex: number, pageSiza: number, search?: any): Observable<any> {
        let url = `/api/runtime/wf/v1.0/dtProcDefs/getHelpData?helpId=${helpId}&pageIndex=${pageIndex}&pageSize=${pageSiza}`;
        if (search) {
            url += `&searchValue=${JSON.stringify(search)}`;
        }
        return this.http.get(url);
    }
    getHelpMetaData(helpId: string, su: string): Observable<any> {
        const url = `/api/runtime/lcm/v1.0/rt-metadatas/${helpId}`;
        return this.http.get(url);
    }
}
